import { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// @mui material components
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 3 PRO React components
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import FormSelect from "components/DigiHapi/FormSelect";
import ImageUpload from "components/CustomUpload/ImageUpload";

import { fetchGetGoodDealsCategories } from "actions/gooddeal";
import {
	fetchGetTemplates,
	fetchGetGoodDealsTemplates
} from "actions/template";
import {
	REMOVE_GOODDEALS_IMAGE,
	SET_GOODDEALS_FILES_IMAGES,
	SET_GOODDEALS_CATEGORY,
	SET_IMAGE_ERROR,
	SET_TITLE_ERROR,
	SET_GOODDEALS_TITLE_FR,
	SET_GOODDEALS_TEMPLATE,
	SET_GOODDEALS_CUSTOM_URI,
	SET_CUSTOM_URI_ERROR
} from "actions/types";

class Step1 extends Component {
	componentDidMount() {
		const {
			fetchGetGoodDealsCategories,
			fetchGetTemplates,
			fetchGetGoodDealsTemplates,
			templatesUsedByGooddeals,
			community
		} = this.props;
		fetchGetGoodDealsCategories();
		if (!templatesUsedByGooddeals) {
			fetchGetTemplates("Activity", community._id);
			fetchGetGoodDealsTemplates();
		}
	}

	sendState() {
		return this.state;
	}

	isValidated() {
		const { dispatch, title, files, photoUri, customUri } = this.props;

		let success = true;
		if (files.length === 0 && !photoUri) {
			dispatch({
				type: SET_IMAGE_ERROR
			});
			success = false;
		}
		if (!title) {
			dispatch({
				type: SET_TITLE_ERROR
			});
			success = false;
		}
		if (!customUri || customUri.trim().length === 0) {
			dispatch({
				type: SET_CUSTOM_URI_ERROR
			});
			success = false;
		}
		return success;
	}

	onImageLoaded = (name, imagePreviewUrl) => {
		const { dispatch } = this.props;
		dispatch({
			type: SET_GOODDEALS_FILES_IMAGES,
			payload: [{ name, base64: imagePreviewUrl }]
		});
	};

	onImageRemoved = () => {
		this.props.dispatch({
			type: REMOVE_GOODDEALS_IMAGE
		});
	};

	render() {
		const {
			dispatch,
			imageErrorMsg,
			title,
			titleErrorMsg,
			categoryId,
			photoUri,
			goodDealsCategories,
			templatesUsedByGooddeals,
			templateId,
			templates,
			customUri,
			customUriErrorMsg
		} = this.props;
		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12} sm={4}>
					<MDTypography component="div" variant="h6" mb={1}>
						Image au format paysage *
					</MDTypography>
					<ImageUpload
						onImageLoaded={this.onImageLoaded}
						onImageRemoved={this.onImageRemoved}
						photoUri={photoUri}
					/>
					{imageErrorMsg && (
						<FormHelperText error>{imageErrorMsg}</FormHelperText>
					)}
				</Grid>
				{categoryId && (
					<Grid item xs={12}>
						<FormSelect
							label="Catégorie *"
							value={categoryId}
							placeholder="Sélectionner la catégorie *"
							options={goodDealsCategories}
							onChange={e =>
								dispatch({
									type: SET_GOODDEALS_CATEGORY,
									category: { ...e.target }
								})
							}
						/>
					</Grid>
				)}
				<Grid item xs={12}>
					<MDInput
						label="Titre *"
						id="title"
						fullWidth
						error={!!titleErrorMsg}
						helperText={titleErrorMsg ? titleErrorMsg : undefined}
						value={title ? title : ""}
						onChange={e =>
							dispatch({
								type: SET_GOODDEALS_TITLE_FR,
								value: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="URI *"
						id="uri"
						fullWidth
						error={!!customUriErrorMsg}
						helperText={customUriErrorMsg ? customUriErrorMsg : undefined}
						value={customUri ? customUri : ""}
						onChange={e =>
							dispatch({
								type: SET_GOODDEALS_CUSTOM_URI,
								value: e.target.value
							})
						}
					/>
				</Grid>
				{templatesUsedByGooddeals && (
					<Grid item xs={12}>
						<FormSelect
							label="Activité"
							value={templateId}
							onChange={e =>
								dispatch({
									type: SET_GOODDEALS_TEMPLATE,
									template: templates[e.target.value]
								})
							}
						>
							<MenuItem key="default" value="">
								Sélectionner l'activité
							</MenuItem>
							{templatesUsedByGooddeals.map(({ label, value }) => (
								<MenuItem key={label} value={value}>
									{label}
								</MenuItem>
							))}
						</FormSelect>
					</Grid>
				)}
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		imageErrorMsg,
		title,
		titleErrorMsg,
		categoryId,
		files,
		photoUri,
		templateId,
		customUri,
		customUriErrorMsg
	} = state.gooddealReducer;
	const { community, templatesUsedByGooddeals } = state.entitiesReducer;
	const { templates } = state.templateReducer;
	return {
		templatesUsedByGooddeals:
			templatesUsedByGooddeals &&
			Object.values(templatesUsedByGooddeals).map(obj => ({
				label: obj.name,
				value: obj._id
			})),
		goodDealsCategories: Object.values(
			state.entitiesReducer.goodDealsCategories
		).map(obj => ({
			label: obj.name,
			value: obj._id
		})),
		imageErrorMsg,
		title,
		titleErrorMsg,
		categoryId,
		files,
		photoUri,
		community,
		templateId,
		templates,
		customUri,
		customUriErrorMsg
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchGetGoodDealsCategories,
			fetchGetGoodDealsTemplates,
			fetchGetTemplates
		},
		dispatch
	);
	return { ...actions, dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
	forwardRef: true
})(Step1);
